var _desc, _rect, _rect2, _circle, _circle2, _circle3, _circle4, _rect3, _rect4, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Car Transportation Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Car driving directions icon")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 50,
    width: 50,
    height: 20,
    rx: 8,
    fill: "#5F7A61",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 40,
    width: 30,
    height: 15,
    rx: 6,
    fill: "#F5F0E6",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 75,
    r: 8,
    fill: "#E5DECF",
    stroke: "#F5F0E6",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 75,
    r: 8,
    fill: "#E5DECF",
    stroke: "#F5F0E6",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 75,
    r: 4,
    fill: "#F5F0E6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 75,
    r: 4,
    fill: "#F5F0E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 43,
    width: 10,
    height: 10,
    rx: 2,
    fill: "white",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 43,
    width: 10,
    height: 10,
    rx: 2,
    fill: "white",
    opacity: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 45,
    x2: 20,
    y2: 45,
    stroke: "#E5DECF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 50,
    x2: 18,
    y2: 50,
    stroke: "#E5DECF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 55,
    x2: 22,
    y2: 55,
    stroke: "#E5DECF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car-icon.9f17d2f3bad3d62a20437fed3fe60dac.svg";
export { ForwardRef as ReactComponent };